<h3 class="text-center">Compartir</h3>
<div class="col-md-12" [hidden]="(task.status == 'QUOTED' || task.status == 'INVOICED')">
  - compartir permitido sólo para Presupuestos y Facturas -
</div>
<div class="col-md-12" [hidden]="!(task.status == 'QUOTED' || task.status == 'INVOICED')">
  <div class="center-block">
    <button type="button" class="btn btn-outline-lavuro mr-3" (click)="download()" [disabled]="saving"
      *ngIf="showDownload">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share"
        viewBox="0 0 16 16">
        <path
          d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z">
        </path>
      </svg>
      <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span> Descargar
    </button>

    <button type="button" class="btn btn-lavuro mr-3" (click)="sendEmail()" [disabled]="sending" *ngIf="showEmail">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share"
        viewBox="0 0 16 16">
        <path
          d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z">
        </path>
      </svg>
      <span *ngIf="sending" class="spinner-border spinner-border-sm mr-1"></span> Enviar por email
    </button>

    <button type="button" class="btn btn-success mr-3" (click)="shareByWhatsapp()" *ngIf="showWhatsapp">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share"
        viewBox="0 0 16 16">
        <path
          d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z">
        </path>
      </svg>
      Enviar por Whatsapp
    </button>
  </div>
</div>